// src/redux/classSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { get_shopingcart,add_cart,delete_cart } from "../Service/ApiServices";
import { toast } from "react-toastify";
const initialState = {
  cartlists: [],
  school_id: "",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addloading:false
};

// Async Thunks for API Calls


export const fetchcartlist = createAsyncThunk(
  "cartlists/fetchcartlist",
  async ({token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_shopingcart(token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


 
export const createcart = createAsyncThunk(
  "cartlists/createcart",
  async ({ product_id, school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_cart(product_id, school_id, token, signal);

        console.log("responsecart",response);
       
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



export const deletecartlist = createAsyncThunk(
    "cartlists/deletecartlist",
    async ({cartitem_id,school_id, token, signal}, { rejectWithValue }) => {
      try {
        const response = await delete_cart(cartitem_id,school_id, token, signal);
        if (response.status) {
          return response.response;
        } else {
          return rejectWithValue(response.response);
        }
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
 


const createwhishlist = createSlice({
  name: "cartlists",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
 
    setwhishlist(state, action) {
      state.whishlists = action.payload;
    },

    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
 
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
   extraReducers: (builder) => {
    builder
           // Fetch Classes
      .addCase(fetchcartlist.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchcartlist.fulfilled, (state, action) => {
        state.loading = false;
        state.cartlists = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchcartlist.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createcart.pending, (state) => {
             state.addloading = true;
           })
        .addCase(createcart.fulfilled, (state, action) => {
            state.addloading = false;
            toast.success(action?.payload?.message || "Something went wrong!");
        })
        .addCase(createcart.rejected, (state, action) => {
            state.addloading = false;
            state.error = action?.payload?.data?.message;
            const errorMessage = action?.payload?.data?.message || "Something went wrong!";
            toast.info(errorMessage);  
            state.IsEditing = false;
        })
        .addCase(deletecartlist.pending, (state) => {
            state.addloading = true;
          })
       .addCase(deletecartlist.fulfilled, (state, action) => {
           state.addloading = false;
           toast.success(action?.payload?.message || "Something went wrong!");
       })
       .addCase(deletecartlist.rejected, (state, action) => {
           state.addloading = false;
           state.error = action?.payload?.data?.message;
           const errorMessage = action?.payload?.data?.message || "Something went wrong!";
           toast.info(errorMessage);  
           state.IsEditing = false;
       });
    },
});

// Export the actions and the reducer
export const {
    setActivePage,
    setwhishlist,
    setPageSize,
    setSchoolId

} = createwhishlist.actions;
export default createwhishlist.reducer;
